import { webPortalApi } from '#config/web-portal-api';
import { PUSH_ERROR, ERROR } from './types';
import { getRequestOptions } from '#helper';

export function error(e) {
  return {
    type: PUSH_ERROR,
    payload: e
  };
}

export function snackBarError(e) {
  return {
    type: ERROR,
    payload: e
  };
}

async function pageGluer(r, options = {}, pathPart, data) {
  const maxPageLength = parseInt(r.headers.get('Max-Page-Length'), 10);
  const totalCount = parseInt(r.headers.get('Total-Count'), 10);
  if (totalCount && maxPageLength) {
    const count = Math.ceil(totalCount / maxPageLength) - 1;
    const { limit, dataAttr, paramPrefix } = options;
    await Promise.all([...new Array(count)]
      .map(async (n, i) => {
        const params = new URLSearchParams({ limit, offset: limit * (i + 1) });
        const res = await fetch(webPortalApi.buildApiUrl(`${pathPart}${paramPrefix}${params.toString()}`), getRequestOptions());
        if (!res.ok) {
          throw new TypeError('Error in request');
        }
        const d = await res.json();
        data.push(...(dataAttr ? d[dataAttr] : d));
      })).catch(e => console.error('pageGluer', e));
  }
}

export function fetchAdditions(pathPart, eventName, mixture = {}, pagesGlue) {
  return (dispatch, getState) =>
    fetch(webPortalApi.buildApiUrl(pathPart), getRequestOptions())
      .then(r =>
        r.json().then(async data => {
          if (!r.ok) {
            return dispatch(
              snackBarError({
                message: 'Error in request',
                ...data
              })
            );
          }

          if (pagesGlue && r.status === 206) {
            await pageGluer(r, { limit: pagesGlue.limit, paramPrefix: '&' }, pathPart, data);
          }

          return dispatch({
            type: eventName,
            payload: data,
            store: getState(),
            ...mixture
          });
        }))
      .catch(e => {
        console.error(e);
        return dispatch(
          error({
            message: 'Error in request'
          })
        );
      });
}

export const fetchJson = async url => {
  try {
    const res = await fetch(url, getRequestOptions());
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }

    const response = await res.json();

    if (!res.ok) {
      throw response;
    }

    return response;
  } catch (err) {
    console.error(err);
    return err;
  }
};
